import tw from "tailwind-styled-components";
import { MdClose } from "react-icons/md";
import moment from "moment";
import { ScrollableContent } from "../Styles/InputStyles";
import { capitalizeFirstLetter, getLandlordTransactionFor, getModeName } from "../../helpers";
import { Link } from "react-router-dom";

const ViewTransDetails = ({
    setViewDetail,
    selectedData,
}) => {
    const onClose = () => {
        setViewDetail(false);
    };

    return (
        <>
            <Container>
                <Header>
                    <Title>Payment Details</Title>
                    <button onClick={onClose}>
                        <MdClose color="white" size={24} />
                    </button>
                </Header>
                <ProfileSection className="flex justify-between">
                    <UserInfo>
                        <span className="font-medium mb-0">
                            {capitalizeFirstLetter(selectedData?.landlordName || 0)}
                        </span>
                        <span className="text-sm text-gray-600">
                            {'#' + selectedData?.landlordMobile}
                        </span>
                    </UserInfo>
                    <div className="flex flex-col gap-0">
                        <span className='text-gray-500 text-sm'>{'Amount'}</span>
                        <span className='text-xl font-semibold text-gray-700'>{'₹' + selectedData?.amount}</span>
                    </div>
                </ProfileSection>
                <Content>
                    <ScrollableContent>
                        <Wrapper>
                            <BtnWrapper>
                                <SectionTitle>Payment Information</SectionTitle>
                            </BtnWrapper>
                            <Section>
                                <Row>
                                    <FlexCol>
                                        <Label>Payment Type</Label>
                                        <Value>{getLandlordTransactionFor(selectedData)}</Value>
                                    </FlexCol>
                                    <FlexCol>
                                        <Label>For Property</Label>
                                        <Value>{selectedData?.propertyName || "-"}</Value>
                                    </FlexCol>
                                </Row>
                                <Row>
                                    <FlexCol>
                                        <Label>Due Date</Label>
                                        <Value>{moment(selectedData.dueDate).format("DD, MMM YY")}</Value>
                                    </FlexCol>
                                    <FlexCol>
                                        <Label>Payment Date</Label>
                                        <Value>{moment(selectedData.paidDate).format("DD, MMM YY")}</Value>
                                    </FlexCol>
                                </Row>
                                <Row>
                                    <FlexCol>
                                        <Label>Payment Mode</Label>
                                        <Value>{getModeName(selectedData?.paymentMethod)}</Value>
                                    </FlexCol>
                                    {/* <FlexCol>
                                        <Label>Payment Date</Label>
                                        <Value>{moment(selectedData?.paymentDate).format("DD-MMM-YY")}</Value>
                                    </FlexCol> */}
                                    <FlexCol>
                                        <Label>Paid By</Label>
                                        <Value>{selectedData?.paidByName ? selectedData?.paidByName : '--'}</Value>
                                    </FlexCol>
                                </Row>
                                <Row >
                                    <FlexCol >
                                        <Label>Bank Reference Number</Label>
                                        <Value>{selectedData?.bankRefNum ? selectedData?.bankRefNum : '--'}</Value>
                                    </FlexCol>
                                </Row>
                                <Row className='grid-cols-1'>
                                    <FlexCol >
                                        <Label>Description</Label>
                                        <Value>{selectedData?.description || "--"}</Value>
                                    </FlexCol>
                                </Row>
                            </Section>
                            {selectedData?.remarks &&
                                <>
                                    <BtnWrapper>
                                        <SectionTitle>Remarks</SectionTitle>
                                    </BtnWrapper>
                                    <Section>
                                        <Value>{selectedData?.remarks || "--"}</Value>
                                    </Section>
                                </>
                            }
                            <div className="flex justify-end">
                                <FlexCol>
                                    <Value className="text-blue-500 underline">
                                        <Link
                                            to={selectedData?.supportDoc}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {selectedData?.supportDoc?.split("/").pop()}
                                        </Link>
                                    </Value>
                                </FlexCol>
                            </div>
                        </Wrapper>
                    </ScrollableContent>
                </Content>
            </Container >


        </>
    );
};

const Header = tw.div`flex items-center justify-between bg-[#26A69A] py-4 px-4`;
const Wrapper = tw.div`grid gap-2 my-0`;
const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
const Content = tw.div`p-4 flex flex-col gap-4`;
const Title = tw.h1`text-lg md:text-xl font-medium text-center text-white`;
const Section = tw.div`border border-gray-200 p-2 rounded-lg mb-3`;
const SectionTitle = tw.h2`text-base font-medium text-gray-600 flex justify-between items-center`;
const Row = tw.div`grid grid-cols-2 py-1 md:p-1`;
const Label = tw.label`text-sm text-gray-400 font-normal`;
const Value = tw.span`text-gray-600 text-md`;
const BtnWrapper = tw.div`w-full flex items-center justify-between`;
const FlexCol = tw.div`flex flex-col gap-0.5`;
const UserInfo = tw.div`flex flex-col`;
const ProfileSection = tw.div`flex items-center gap-3 bg-gray-100 px-4 p-4`;

export default ViewTransDetails;